<template>
  <Select v-model="value"
          :data-title="$t('message.generics.message.status')"
          :data-menu-heading="$t('message.generics.message.status')"
          data-menu-width="350px"
          :data-button-gradient="true"
          :data-items="options"
          @input="setOperationsFilter"
          @search="searchIds($event)" />
</template>

<script>
    import Select from '@components/Select'

    export default {
        components: {
          Select
        },

        data() {
            return {
              initalOptions: [
                {
                  label: this.$t('message.monitoring.message.open'),
                  id: 'OPEN'
                },
                {
                  label: this.$t('message.monitoring.message.resolving'),
                  id: 'RESOLVING'
                },
                {
                  label: this.$t('message.monitoring.message.closed'),
                  id: 'CLOSED'
                },
                {
                  label: this.$t('message.monitoring.message.autoClosed'),
                  id: 'AUTO_CLOSED'
                }
              ],
              options: [],
              value: []
            }
        },

        methods: {
          setOperationsFilter(val) {
            this.$store.commit('SYSTEMWARNING_SET_FILTER', {key: 'status', value: val})
          },
          searchIds(search) {
            this.options = search ? this.initalOptions.filter((option) => {
              return option.label.includes(search);
            }) : this.initalOptions;
          },
        },

        async mounted() {
          this.options = [...this.initalOptions];
        },
    }
</script>

<style scoped>
</style>
